/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type DeadlineUnit = typeof DeadlineUnit[keyof typeof DeadlineUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeadlineUnit = {
  Hours: 'Hours',
  Days: 'Days',
  Weeks: 'Weeks',
} as const;
